import React from 'react'
import styled from 'styled-components'

import {DATE_FORMAT} from '../../config/DateFormat'
import {strToDate} from '../../utils/utils'
import {dicomDateToDate, formatNoUTCDate} from '../../utils'
import { DEST_EXISTING, DEST_NEW, buildName } from './ChangePatientDialog'
import { Icon } from '@startlibs/components'
import { formatDate } from '@startlibs/utils'

const Striked = styled.span`
  text-decoration: line-through;
`

const TRANSFORM_DATE_FORMAT = "yyyyMMdd"

export const CurrentPatientStudyCard = styled(({study, className, patientName, patientID, patientDOB, fValues}) => {

  const studyDate = strToDate(study.study.studyDate)
  const formattedStudyDate = isNaN(studyDate.getTime()) ? "" : formatNoUTCDate(studyDate,DATE_FORMAT())

  const dob = dicomDateToDate(patientDOB)
  const formattedDob = isNaN(dob.getTime()) ? "" : formatNoUTCDate(dob, DATE_FORMAT(), undefined, true)

  const newPatientName = (fValues && fValues.destination === DEST_NEW && (fValues?.firstName?.length > 0 || fValues?.lastName?.length > 0))
    ? buildName({firstName: fValues.firstName, lastName: fValues.lastName, middleName: fValues.middleName}).replace(/\^/g, ' ').trim()
    : fValues && fValues.destination === DEST_EXISTING && fValues?.selectedPatient?.patient?.patientName
      ? fValues?.selectedPatient?.patient?.patientName.replace(/\^/g, ' ').trim()
      : undefined
  const newPatientID = fValues && fValues.destination === DEST_NEW && fValues?.patientID
    ? fValues.patientID
    : fValues && fValues.destination === DEST_EXISTING && fValues?.selectedPatient?.patient?.patientID
      ? fValues.selectedPatient.patient.patientID
      : undefined
  const newPatientDOB = fValues && fValues.destination === DEST_NEW && fValues.patientDOB 
    ? fValues.patientDOB === -1 ? 'Invalid date' : formatDate(fValues.patientDOB,TRANSFORM_DATE_FORMAT) 
    : fValues && fValues.destination === DEST_EXISTING 
      ? fValues?.selectedPatient?.patient 
        ? fValues?.selectedPatient?.patient?.patientDOB != null ? fValues.selectedPatient.patient.patientDOB : 'null'
        : undefined
      : 'null'
  const newDob = newPatientDOB && newPatientDOB != 'null' ? dicomDateToDate(newPatientDOB) : newPatientDOB == 'null' ? 'null' : undefined
  const formattedNewDob = newPatientDOB && newPatientDOB != 'null' && newPatientDOB != 'Invalid date'
    ? isNaN(newDob.getTime()) 
      ? "" 
      : formatNoUTCDate(newDob, DATE_FORMAT(), undefined, true) 
    : newPatientDOB == 'null' || newPatientDOB == "Invalid date"
      ? newPatientDOB
      : undefined
  
  return <div className={className}>
    <div className="study-info notranslate"><b>Study: </b>{study.study.modalities} - {study.study.studyDescription} <span className="nowrap">({formattedStudyDate})</span></div>
    <div className="study-info notranslate"><b>Current patient: </b>
      {newPatientName 
        ? <>
            <span className="notranslate"><Striked>{patientName.replace(/\^/g, ' ').trim()}</Striked> </span>
            { <Icon icon="long-arrow-right"></Icon>}
            <span className="notranslate">{` ${newPatientName}`}</span>
          </>
        : patientName.replace(/\^/g, ' ').trim()
      }
    </div>
    <div className="study-info"><b>Patient ID: </b> 
      {newPatientID
        ? <>
            <span className="notranslate"><Striked>{patientID}</Striked> </span>
            { <Icon icon="long-arrow-right"></Icon>}
            <span className="notranslate">{` ${newPatientID}`}</span>
          </>
        : patientID
      }
    </div>
    <div className="study-info"><b>Patient DOB: </b> 
      {formattedNewDob
        ? <>
            <span><Striked>{formattedDob}</Striked> </span>
            { <Icon icon="long-arrow-right"></Icon>}
            <span>{` ${formattedNewDob}`}</span>
          </>
        : formattedDob
      }
    </div>
  </div>
})`
  border-radius: 6px;
  border: 1px solid rgba(0,0,0,0.25);
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  .study-info {
    color: rgba(0,0,0,0.7);
    margin-top: 2px;
    font-size: 12px;
  }
  & ~ & {
    margin-top: -1rem;
  }
`